// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"fc741cf57e9647f370a3","2762":"237edaedd7c8100a5848","3632":"cc7b74c8958462f45def","5862":"142cd48ca8ec32e57725","6366":"34536a1301a55ba74be8","7874":"cd16576625b0c6e0d277"}[chunkId] + "";
};